import React, {useMemo} from 'react';
import {tableColumnsWithProps} from './columns';
import CommercialTable from '../../../common/components/commercialTable/commercialTable';

export const DailyQuotaTable = ({dataTable, updateMyData}) => {
  const columnsTable = tableColumnsWithProps(updateMyData);
  const data = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => columnsTable, []);

  return (
    <CommercialTable
      columns={columns}
      data={data}
      isSmallCell={true}
      pagination={false}
      tableType={'fixed'}
    />
  );
};
